<template>
    <div component="ListAndDetail" :isDetail="isDetail">
        <transition name="list">
            <div class="list" v-show="!isDetail">
                <scroll-table :list="list" :config="config" :clickable="true" :draggable="false"></scroll-table>
            </div>
        </transition>

        <transition name="detail">
            <div class="detail" v-show="isDetail">
                <scroll-table-detail>
                    <slot name="detail"></slot>
                </scroll-table-detail>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ScrollTable from '@/components/.global/ScrollTable/ScrollTable.vue';
import ScrollTableDetail from '@/components/.global/ScrollTable/ScrollTableDetail.vue';

export default {
    name: 'ListAndDetail',

    props: {
        list: {
            type: Array,
            required: false,
        },

        isDetail: {
            type: Boolean,
            required: true,
        },

        config: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {};
    },

    methods: {
        hideDetail() {
            this.$router.push({
                path: this.$route.path.split('/').slice(0, -1).join('/'),
            });
        },

        ...mapActions(['loadContract']),
    },

    components: {
        ScrollTable,
        ScrollTableDetail,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ListAndDetail'] {
    width: 100%;
    height: 100%;
    position: relative;

    @media (min-width: 768px) {
        height: 100%;
        overflow: hidden;
    }

    .list-enter,
    .list-leave-to {
        opacity: 0;
        transform: translateY(-100%);
        position: absolute !important;
        overflow: hidden;
    }

    .list-enter-active,
    .list-leave-active {
        transition: all 0.5s;
    }

    .list-enter-to {
        opacity: 1;
        transform: translateY(0%);
        position: absolute !important;
    }

    .detail-enter,
    .detail-leave-to {
        opacity: 0;
        transform: translateY(100%);
        position: absolute !important;
        overflow: hidden;
    }

    .detail-enter-active,
    .detail-leave-active {
        transition: all 0.5s;
    }

    .detail-enter-to {
        opacity: 1;
        transform: translateY(0%);
        position: absolute !important;
    }

    .list {
        height: 100%;
        width: 100%;
        position: absolute;
    }

    .detail {
        height: 100%;
        width: 100%;
        position: relative;

        button.close {
            position: absolute;
            right: 15px;
            top: 15px;
        }

        @media (orientation: landscape) {
        }
    }

    // &[isDetail="true"]{
    // 	.list{
    // 		transform: translate3d(0%, -100%, 0);
    // 	}
    // 	.detail{
    // 		transform: translate3d(0%, -100%, 0);
    // 	}
    // }
}
</style>
